export default __webpack_public_path__ + "static/media/methodology.bdf5be67.png";